import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/deals/[id]/deal_estimation_headers/[headerId]/Page";

export const PATH = (id: number, headerId: number): string =>
	`/deals/${id}/deal_estimation_headers/${headerId}`;

function DealEstimationHeaders() {
	return (
		<>
			<NskHead title="見積り履歴確認" />
			<Component />
		</>
	);
}

export default DealEstimationHeaders;
